import React from 'react';

import {
    ASSIGNMENTS_DIALOG_PATH,
    MFE_DIALOG_PREFIX,
    WORKSHOPS_DIALOG_PATH,
} from '@/features/common/components/dialogs/dialogConstants';
import { RemoteDialog } from '@/features/common/components/dialogs/RemoteDialog';
import { ColumnConfig, TableRowProps } from '@/features/common/components/maintenance-table/types';
import { getDetailViewHrefFor } from '@/features/utils';

const getRendererFor = (columns: ColumnConfig[], columnName: string) =>
    columns.find((col) => col.name === columnName && !col.hidden)?.renderer;

// @TODO: Currently using query params to navigate to Wear & Fill Levels Tab since we only have the Brake Lining Table
// When additional tables are implemented, this navigation logic should be made dynamic
const renderWithLink = (renderer: (row: any) => React.ReactNode, row: any) => (
    <a
        href={`${getDetailViewHrefFor(row.asset.id)}?tab=VIEW_DETAIL_WEAR_AND_FILL_LEVELS`}
        className="hover-text-decoration-none"
        target="_parent"
    >
        <span className="rioglyph rioglyph-angle-double-right text-color-danger text-size-14 margin-top-0 width-15" />
        &nbsp;{renderer(row)}
    </a>
);

export const TableRow = ({ rows, columns, rowStatusMapper, rowDetailRenderer, rowKeyMapper }: TableRowProps) => {
    let lastVin: string | null = null;
    let lastCss: 'even' | 'odd' = 'odd';
    const vehicleColumnRenderer = getRendererFor(columns, 'vehicle');
    const vinColumnRenderer = getRendererFor(columns, 'vin');
    const customerColumnRenderer = getRendererFor(columns, 'customer');
    const workshopColumnRenderer = getRendererFor(columns, 'workshop');

    return rows?.map((row, index) => {
        let className = lastCss;
        if (lastVin !== row.asset.vin) {
            className = lastCss === 'even' ? 'odd' : 'even';
            lastCss = `${className}`;
        }
        lastVin = row.asset.vin;
        const rowKey = rowKeyMapper?.(row) || `${row.asset.id}-${index}`;
        return (
            <tr key={rowKey} className={`${className} ${rowStatusMapper(row)}`}>
                {vehicleColumnRenderer && <td data-field="vehicle">{renderWithLink(vehicleColumnRenderer, row)}</td>}

                {vinColumnRenderer && (
                    <td data-field="vin">
                        {vehicleColumnRenderer ? (
                            <span>{vinColumnRenderer(row)}</span>
                        ) : (
                            renderWithLink(vinColumnRenderer, row)
                        )}
                    </td>
                )}

                {customerColumnRenderer && (
                    <td data-field="customer">
                        <RemoteDialog path={`${ASSIGNMENTS_DIALOG_PATH}/${row.asset.id}`}>
                            {customerColumnRenderer(row)}
                        </RemoteDialog>
                    </td>
                )}

                {workshopColumnRenderer && (
                    <td data-field="workshop">
                        <RemoteDialog path={`${WORKSHOPS_DIALOG_PATH}/${row.workshop.id}`}>
                            {workshopColumnRenderer(row)}
                        </RemoteDialog>
                    </td>
                )}
                {rowDetailRenderer(row)}
            </tr>
        );
    });
};
